import { render, staticRenderFns } from "./InputComent.vue?vue&type=template&id=0dd783c0&scoped=true&"
import script from "./InputComent.vue?vue&type=script&lang=js&"
export * from "./InputComent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd783c0",
  null
  
)

export default component.exports